// extracted by mini-css-extract-plugin
export var active = "_2s-9";
export var backButton = "_2s-8";
export var clone = "_2s-e";
export var collapseBar = "_2s-j";
export var collapseMode = "_2s-l";
export var collapsed = "_2s-n";
export var dragHandle = "_2s-c";
export var dropdownIcon = "_2s-g";
export var expanding = "_2s-m";
export var hidden = "_2s-w";
export var iconContainer = "_2s-p";
export var iconSwapper = "_2s-v";
export var navItem = "_2s-6";
export var navItemIcon = "_2s-f";
export var navProfile = "_2s-7";
export var notificationCountBadge = "_2s-i";
export var notificationDot = "_2s-q";
export var optionsContainer = "_2s-h";
export var primaryNav = "_2s-0";
export var primaryNavDivider = "_2s-u";
export var primaryNavResizeHandle = "_2s-2";
export var primaryNavResizing = "_2s-1";
export var primaryNavTabSection = "_2s-t";
export var primaryTab = "_2s-o";
export var primaryTabIconBox = "_2s-r";
export var secondaryNav = "_2s-3";
export var selected = "_2s-s";
export var settingsNav = "_2s-4";
export var settingsNavItems = "_2s-5";
export var show = "_2s-d";
export var sideNav = "_2s-k";
export var teamItem = "_2s-a";
export var userProfileItem = "_2s-b";